import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  constructor(private http: HttpClient) {}

  getGeolocation() {
    return this.http.get('https://geo.wpforms.com/v3/geolocate/json');
  }
}
